<div class="modal-content">
  <div class="modal-header">
    <p class="modal-title font-16 mb-0 text-dark">
      <span>{{ 'employees.change_active_access' | translate }}</span>
    </p>
    
    <button
        (click)="activeModal.dismiss()"
        aria-label="Close"
        class="close"
    >
                    <span
                        aria-hidden="true"
                        class="font-24 text-muted"
                    >
                      <i class="mdi mdi-close"></i>
                    </span>
    </button>
  </div>
  <div class="modal-body">
    <form
        (ngSubmit)="onSubmit()"
        [formGroup]="form"
    >
      <ng-container *ngIf="employee">
        <div class="row mb-3">
          <div class="col-6">
            <span class="text-dark">{{ 'employees.access_to_application' | translate }}</span>
          </div>
          
          <div class="col-6 text-right">
            <span *ngIf="employee?.has_active_access">
              <span class="mdi mdi-check-circle-outline mr-1 text-green"></span>{{ 'global.YES' | translate }}
              <span *ngIf="employee?.has_active_access_to">({{ 'global.to' | translate }} {{ employee?.has_active_access_to | date:'dd.MM.yyyy' }})</span>
            </span>
            <span *ngIf="!employee?.has_active_access">
              <span class="mdi mdi-close-circle-outline mr-1 text-red"></span>{{ 'global.NO' | translate }}
              <span *ngIf="employee?.has_password">({{ 'employees.has_password' | translate }})</span>
              <span *ngIf="!employee?.has_password">({{ 'employees.does_not_have_password' | translate }})</span>
            </span>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="!employee?.has_active_access && !user?.is_active">
        <div class="row mb-2">
          <div class="col-12">
            <span>{{ translateEntity + '.no_active_access_text' | translate }}</span>
          </div>
        </div>
        <ng-container [ngTemplateOutlet]="lastLoginTemplate"></ng-container>
        <div *ngIf="employee" class="row">
          <div class="col-5 d-flex align-items-center mb-2">
            <label class="control-label m-0">
              <span>{{ 'employees.email_to_login' | translate }}</span>
            </label>
          </div>
          <div class="col-7 mb-2">
            <input
                (keyup)="inputChanged($event)"
                autocomplete="none"
                class="form-control"
                formControlName="email"
                name="email"
                type="text"
            >
          </div>
          <div class="col-12">
            <div *ngIf="emailTaken === true">
              <p class="text-danger">
                <span>{{ 'users.email_taken' | translate }}</span>
              </p>
            </div>
            <div *ngIf="form.controls?.email?.errors">
              <p *ngIf="form.controls?.email?.errors?.required" class="text-danger">
                <span>{{ 'angular_validation.field' | translate }} </span>
                <span>{{ 'employees.email_to_login' | translate }} </span>
                <span>{{ 'angular_validation.required' | translate }}</span>
              </p>
              
              <p *ngIf="form.controls?.email?.errors?.email" class="text-danger">
                <span>{{ 'angular_validation.valid_email' | translate }}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <label class="control-label">{{ translateEntity + '.send_invite' | translate }}</label>
          </div>
          <div class="col-auto text-right align-self-center">
            <div>
              <input data-switch="success" formControlName="send_invite" id="send_invite" name="send_invite" type="checkbox">
              <label for="send_invite">&nbsp;</label>
            </div>
          </div>
        </div>
        <div *ngIf="form.controls?.email?.value !== employee?.email" class="row">
          <div class="col-12 text-right">
            <small class="text-muted">
              {{ 'employees.email_change_description' | translate }}
            </small>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12 text-right">
            <button [disabled]="form.controls?.email?.errors || emailTaken" class="btn btn-primary" style="padding-left: 8px !important; padding-right: 8px !important;" submitButton type="submit">
              <span>{{ translateEntity + '.action_activate_employee' | translate }}</span>
            </button>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="employee?.has_active_access || user?.is_active">
        <div class="row mb-1">
          <div class="col-12">
            <span>{{ translateEntity + '.active_access_text' | translate }}</span>
          </div>
        </div>
        <div class="row mb-1">
          <div class="col-12">
            <span>{{ translateEntity + '.change_password_text' | translate }} </span>
          </div>
        </div>
        <div class="row mb-1">
          <div class="col-12">
            <span>{{ translateEntity + '.send_invite_text' | translate }} </span>
          </div>
        </div>
        <ng-container [ngTemplateOutlet]="lastLoginTemplate"></ng-container>
        <div *ngIf="employee?.has_active_invitation || user?.has_active_invitation" class="row">
          <div class="col-12 alert alert-warning">
            <span>{{ translateEntity + '.has_active_invitation_text' | translate }} </span>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12 col-sm text-right p-1">
            <button (click)="resetPassword()" class="btn btn-primary" style="min-width: 0 !important; padding-left: 6px !important; padding-right: 6px !important;" type="button">
              <span>{{ translateEntity + '.change_password_action' | translate }}</span>
            </button>
          </div>
          <div class="col-12 col-sm-auto text-right p-1">
            <button (click)="sendInvitation()" class="btn btn-primary" style="min-width: 0 !important; padding-left: 6px !important; padding-right: 6px !important;" type="button">
              <span>{{ translateEntity + '.send_invite' | translate }}</span>
            </button>
          </div>
          <div class="col-12 col-sm-auto text-right pl-1 py-1 pr-0">
            <button class="btn btn-primary" style="min-width: 0 !important; padding-left: 6px !important; padding-right: 6px !important;" submitButton type="submit">
              <span>{{ translateEntity + '.action_deactivate_employee' | translate }}</span>
            </button>
          </div>
        </div>
      </ng-container>
    </form>
  </div>
</div>

<ng-template #lastLoginTemplate>
  <div class="row mb-2">
    <div class="col"> {{ translateEntity + '.last_logged_at' | translate }}:</div>
    <div *ngIf="employee?.last_logged_at || user?.last_logged_at; else notLoggedTemplate" class="col-auto text-right font-weight-bold">
      {{ (employee?.last_logged_at || user?.last_logged_at) | date: 'dd.MM.yyyy HH:mm' }}
    </div>
    <ng-template #notLoggedTemplate>
      <div class="col-auto text-right font-weight-bold">
        {{ translateEntity + '.not_logged_yet' | translate }}
      </div>
    </ng-template>
  </div>
</ng-template>
